'use strict';

var GridExportCsvButtonDirective = function GridExportCsvButtonDirective() {
  return {
    restrict: 'E',
    require: '^^rmGridToolbar',
    scope: true,
    template: require('../templates/grid-export-csv-button.html'),
    controller: 'GridExportCsvButtonController'
  };
};
GridExportCsvButtonDirective.$inject = [];
module.exports = GridExportCsvButtonDirective;